import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError } from "rxjs";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private readonly router = inject(Router);

    public intercept(request: HttpRequest<any>, next: HttpHandler) {
        return next.handle(request.clone()).pipe(
            catchError((error: unknown) => {
                const normalizedError = this.normalizeError(error);

                if (normalizedError) {
                    return throwError(() => normalizedError);
                }

                return throwError(() => error);
            })
        );
    }

    private normalizeError(error: any): any {
        if (error instanceof Error) {
            return error;
        }

        if (error instanceof HttpErrorResponse) {
            this.handleHttpError(error);
            return;
        }
    }

    private handleHttpError(e: HttpErrorResponse) {
        if (e.status === 401) {
            this.router.navigate(["/login"]);
        } else if (e.status === 403) {
            this.router.navigate(["/dashboard/error/403"]);
        } else if (e.status === 404) {
            this.router.navigate(["/dashboard/error/404"]);
        } else if (e.status === 500 || e.status === 0) {
            this.router.navigate(["/dashboard/error/500"]);
        }
    }
}
